import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  BillingSupplyAuthorizationEstimate,
  BillingSupplyAuthorizationEstimateResponse,
} from '@/features/billingBills/types/billingSupplyAuthorizationEstimate.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseBillingSupplyAuthorizationsEstimateProps = {
  billId?: string
}

type UseBillingSupplyAuthorizationsEstimateType = ({
  billId,
}: UseBillingSupplyAuthorizationsEstimateProps) => UseQueryResult<BillingSupplyAuthorizationEstimate, unknown>

export const useBillingSupplyAuthorizationsEstimate: UseBillingSupplyAuthorizationsEstimateType = ({ billId }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<BillingSupplyAuthorizationEstimateResponse, unknown, BillingSupplyAuthorizationEstimate>({
    queryKey: ['billingSupplyAuthorizationsEstimate', billId],
    queryFn: () => {
      return privateAxios.get('/billing/supply_authorizations/estimate', {
        params: { bill_id: billId },
      })
    },
    enabled: !!billId,
    select: (data) => data?.data?.data,
  })
}
